import { action, makeObservable, observable } from 'mobx';

class AppStore {
    constructor() {
        makeObservable(this)
    }

    @observable socketIO: any = null;
    @action setSocketIO(socket: any) {
        this.socketIO = socket;
    }

    @observable transactionStatus: boolean = false;
    @action setTransactionStatus(status: boolean) {
        this.transactionStatus = status;
    }

    @observable loadingStatus: boolean = false;
    @action setLoadingStatus(status: boolean) {
        this.loadingStatus = status;
    }

    @observable loadingPercent: number = 0;
    @action setLoadingPercent(percent: number) {
        this.loadingPercent = percent;
    }

    @action resetLoadingPercent() {
        this.loadingPercent = 0;
    }
}

const store = new AppStore();

export default store;